import axios from "axios";
import { API_BASE } from '../constants/env';
import { store } from '../store';
import { refreshTokenAction } from '../store/Auth/AuthAction';
import * as commontypes from '../store/Common/CommonTypes';
import { canStartTokenRefresh, shouldRefreshJwt } from './jwt';

var client = axios.create({
    baseURL: API_BASE,
    timeout: 30000,
    headers: {
        "Cache-Control": "no-cache",
    },
});

const agentInstance = (prjId: Number) => {
    if (store.getState().auth.isAuthenticated) {
        client.defaults.headers.common['Authorization'] = "Bearer " + store.getState().auth.accessToken;
    }

    client.defaults.headers.common['Accept-Poject'] = store.getState().project.selected.id;
    
    return client;
}

client.interceptors.response.use(response => {
    const auth = store.getState().auth;
    if (
        auth.isAuthenticated &&
        auth.accessToken &&
        !auth.refreshing &&
        shouldRefreshJwt(auth.accessToken) &&
        canStartTokenRefresh()
    ) {
        store.dispatch(refreshTokenAction());
    }
    return response;
}, error => {
    if (error.response?.status === 401) {
        store.dispatch({
            type: commontypes.API_ERROR_401,
            payload: error,
        })
        return Promise.reject(error);
    }
    return Promise.reject(error);
});

export default agentInstance;
